export const trainFields = (roleOptions: any[], categoryOptions: any[]) => [
  {
    name: 'org_chart_node_id',
    label: 'Role',
    type: 'select',
    required: true,
    options: roleOptions,
    placeholder: 'Select role',
  },
  {
    name: 'type',
    label: 'Category',
    type: 'select',
    required: true,
    options: categoryOptions,
    placeholder: 'Select category',
  },
  { name: 'name', label: 'Name', type: 'text', required: true, placeholder: 'Enter training name', colSpan: 2 },
  {
    name: 'description',
    label: 'Description',
    type: 'richtext',
    placeholder: 'Enter training description',
    colSpan: 2,
  },
];
